module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "head",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("This book is part of a series of exciting books about science, technology, and more by Sterling Publishing. We are grateful to Sterling for giving us the chance to participate in this project, and we are thankful to our agent, Matt Wagner, at the Fresh Books Literary Agency for helping to bring the stars into alignment. Peter Wayner helped us come up with the initial list of milestones. Our editor, Meredith Hale, provided terrific support and a bang-up editing job, from the beginning to the end. We are also grateful to the photo researcher, Shana Sobel, for finding such wonderful images to illustrate our 250 milestones, and to our photo editor, Linda Liang, for her work in coordinating the entire process.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We would like to express our thanks to technical reviewers John Abowd, Derek Atkins, Steve Bellovin, Edward Covannon, Flint Dille, Dan Geer, Jim Geraghty, Frank Gibeau, Adam Greenfield, Eric Grunspan, Ethan L. Miller, Danny Bilson, and Amanda Swenty. We would especially like to thank Margaret Minsky, who shared with us her encyclopedic knowledge of computing’s history and made this book far better than it otherwise would have been.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And of course, our greatest thank-yous are to our spouses, Beth Rosenberg and Jon Grunspan, and to our parents, Jill and Joseph Hanig, and Marian and Marvin Garfinkel. Without your gracious support, encouragement, and, above all, patience, this book would not have come to fruition.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e595bf3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9781454926221_epub_ack_r1.vue
// module id = 72
// module chunks = 0